import React from 'react';

function Header(){
  return (<header className="heading"><h1>Note Keeper</h1></header>);
}

export default Header;
